import * as React from 'react'

import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach'
import { NextPage } from '@grandvisionhq/next'
import { Hooks, Types } from '@grandvisionhq/stores-v2'
import { compose } from '@grandvisionhq/utils'
import { Page, Props } from '@grandvisionhq/www-next/pages/stores'

import { withCms, withLayout } from '../cms'

const StoresPage: NextPage<Props | undefined> = (props) => {
  const { routes } = useBloomreachPageRoutes()

  const { useDefaultStoreSearchFilters } = Hooks
  const { openNow, openOnTheWeekend, openOnSunday } = useDefaultStoreSearchFilters()
  const storeSearchFilters: Types.StoreSearchFilterMap | undefined = React.useMemo(() => {
    return !openNow || !openOnTheWeekend || !openOnSunday
      ? undefined
      : { openNow, openOnTheWeekend, openOnSunday }
  }, [openNow, openOnTheWeekend, openOnSunday])

  return (
    <Page
      {...props}
      bookAppointmentUrl={`${routes['appointment-book']}/what`}
      storeSearchFilters={storeSearchFilters}
    />
  )
}

StoresPage.getInitialProps = Page.getInitialProps

export default compose<Props, Props>(withCms(), withLayout())(StoresPage)
